export default "__VITE_ASSET__0896e05a__"